import { Button, Tooltip } from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import AddIcon from '@material-ui/icons/Add';
import format from 'date-fns/format';
import ptBR from 'date-fns/locale/pt-BR';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import Loading from '../../../components/Loading';
import api from '../../../services/api';
import { handleErrorRequest } from '../../../utils/errorsValidation';
import { formatDateToRender, formatDateTimeToRender } from '../../../utils/functions';
import * as S from './styles';
import { useMessageBox } from '../../../context/MessageBox';
import { TOKEN_USER } from '../../../services/auth';
import InputMask from 'react-input-mask';

registerLocale('ptBR', ptBR);

function Anotations({
  provider,
  anchorId,
  statusPropose,
  setAtualizaAbatimentoDesconto,
  atualizarAbatimentoDesconto,
  maxHeight,
  consultarAgendamentos
}) {
  const inputRef = useRef();
  const { setMessageData } = useMessageBox();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [anotations, setAnotations] = useState([]);
  const [newMessage, setNewMessage] = useState(false);
  const [newMessageText, setNewMessageText] = useState('');
  const [timeDate, setTimeDate] = useState('')
  const [scheduleDate, setScheduleDate] = useState(null);

  function isDateBeforeToday(date) {
    return new Date(date.toDateString()) < new Date(new Date().toDateString());
  }

  const fetchAnotations = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `OperacoesAntecipacoes/ConsultarFornecedoresAnotacoes?fornecedorId=${
          provider?.fornecedorId || provider?.[0]?.fornecedorId
        }&ancoraId=${anchorId}`,
      );
      if (response.data.status !== 'Inconsistencia') {
        setAnotations(response.data.resposta);
        setMessageData(response?.data?.complemento?.mensagensBox);
      } else {
        handleErrorRequest(response);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    } finally {
      setAtualizaAbatimentoDesconto(false)
    }
    setIsLoading(false);
  };

  const createNewAnotation = async () => {
    setIsSaving(true);
    try {
      const loginId = JSON.parse(sessionStorage.getItem(TOKEN_USER))?.loginId;
      let newDate;
      if (scheduleDate) {
        const day = scheduleDate.getDate()
        const month = scheduleDate.getMonth()
        const year = scheduleDate.getFullYear()
        let time = timeDate.replaceAll(/[^\d:]/g, '')
        let selectedDate = new Date(year, month, day, -3, 0)
        if(time.length == 5) {
          const timeArray = timeDate.split(':')
          const hour = timeArray[0]
          const minute = timeArray[1]
          selectedDate = new Date(year, month, day, Number(hour)-3, minute)
        } else {
          setIsSaving(false);
          return toast.error('Erro - Hora invalida!');
        }
        newDate = selectedDate.toISOString();
        if (isDateBeforeToday(scheduleDate)) {
          setIsSaving(false);
          return toast.error('Erro - Data selecionada é anterior ao dia de hoje!');
        }
      }

      const bodyRes = {
        ancoraId: anchorId || provider?.ancoraId,
        dataAgendamento: newDate,
        fornecedorId: provider?.fornecedorId,
        loginId: loginId,
        ocorrencia: newMessageText,
      };

      const response = await api.post('/OperacoesAntecipacoes/AdicionarFornecedoresAnotacoes', bodyRes);
      if (response.data.status !== 'Inconsistencia') {
        fetchAnotations();
        consultarAgendamentos(anchorId)
        if(response.data.status !== 'Mensagens') {
          setNewMessageText('');
          setNewMessage(null);
          setScheduleDate(null);
          setTimeDate('')
        }
        setMessageData(response?.data?.complemento?.mensagensBox);
      } else {
        handleErrorRequest(response);
        setIsSaving(false);
        setMessageData(response?.data?.complemento?.mensagensBox);
      }
    } catch (error) {
      handleErrorRequest(error.response);
    }
    setIsSaving(false);
  };

  useEffect(() => {
    if (provider) {
      fetchAnotations();
    }
  }, [provider]);

  useEffect(() => {
    if (provider && atualizarAbatimentoDesconto) {
      fetchAnotations();
    }
  }, [atualizarAbatimentoDesconto]);

  const handleDisabled = () => {
    return !(newMessageText)
  }

  if ((!provider && !isLoading) || statusPropose) {
    return (
      <S.TableTitleHeader>
        <h3 className="operation-title">Anotações</h3>
      </S.TableTitleHeader>
    );
  }

  if (isLoading) {
    return (
      <>
        <S.TableTitleHeader>
          <h3 className="operation-title">Anotações</h3>
        </S.TableTitleHeader>
        <Loading />
      </>
    );
  }

  return (
    <S.AnotationContainer>
      {newMessage && (
        <S.NewAnotation>
          <S.TableTitleHeader>
            <h3 className="operation-title">Nova anotação</h3>
            <Button
              color="primary"
              variant="contained"
              disableElevation
              disabled={isSaving || handleDisabled()}
              onClick={createNewAnotation}
            >
              {isSaving ? 'Gravando...' : 'Gravar'}
            </Button>
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              disabled={isSaving}
              onClick={() => {
                setNewMessage(false);
                setNewMessageText('');
                setScheduleDate(null);
                setTimeDate('')
              }}
            >
              Fechar
            </Button>
          </S.TableTitleHeader>

          <div className="new-body">
            <div className="new-body-left">
              <input
                maxLength="80"
                value={newMessageText}
                className="input-message"
                placeholder="Digite a mensagem"                
                ref={inputRef}
                onChange={(e) =>
                  setNewMessageText(
                    e.target.value
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                  )
                }
              />
            </div>
            <div className="new-body-schedule">
              <div className="schedule-input">
                <span style={{ marginRight: 5 }}>Agendar para</span>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <DatePicker
                    selected={scheduleDate}
                    onChange={(date) => setScheduleDate(date)}
                    dateFormat="dd/MM/yyyy"
                    locale="ptBR"
                    className="input-message"
                  />
                  <InputMask
                    mask="99:99"
                    value={timeDate}
                    className="input-message"
                    placeholder="00:00"
                    onChange={(e) => {
                      let val = e.target.value
                      console.log(val)
                      if(val.includes(':')) {
                        let valArray = val.split(':')
                        let hour = valArray[0]
                        let min = valArray[1]

                        if(Number(hour) > 23) {
                          hour = '23'
                        }

                        if(Number(min) > 59) {
                          min = '59'
                        }

                        val = hour + ':' + min
                      }
                      setTimeDate(val)
                    }}
                  >
                    {() => (
                      <input
                        className="input-message"
                        placeholder="00:00"
                      />
                    )}
                  </InputMask>
                </div>
              </div>
            </div>
          </div>
        </S.NewAnotation>
      )}
      <S.TableTitleHeader>
        <h3 className="operation-title">Anotações</h3>
        <div className="operation-actions">
          {!newMessage && (
            <Tooltip placement="top" title="Nova anotação">
              <AddIcon
                className="pointer"
                onClick={() => {
                  setNewMessage(true);
                  setTimeout(() => {
                    inputRef.current.focus();
                  }, 100);
                }}
              />
            </Tooltip>
          )}
          <Tooltip placement="top" title="Recarregar conteúdo">
            <CachedIcon className="pointer" onClick={() => fetchAnotations()} />
          </Tooltip>
        </div>
        <div className="anotation-body-header">
          <span>Data</span>
          <span className="user-field">Usuário</span>
          <span>Agendamento</span>
        </div>
      </S.TableTitleHeader>

      <S.AnotationBody maxHeight={maxHeight}>
        {anotations?.map((anotation, key) => (
          <div className="anotation-body-message" key={key} style={{
            backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
            color: anotation.corFonte ? anotation.corFonte : 'auto'
          }}>
            <div className="anotation-message-header"
              style={{
                backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
                color: anotation.corFonte ? anotation.corFonte : 'auto'
              }}
            >
              <span className="text-center"
                style={{
                  backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
                  color: anotation.corFonte ? anotation.corFonte : 'auto'
                }}
              >{formatDateTimeToRender(anotation?.dataRegistro)}</span>
              <Tooltip placement="top" title={anotation?.operador}>
                <span className="user-field">
                  {anotation?.operador?.length >= 60
                    ? anotation?.operador?.slice(0, 60) + '...'
                    : anotation?.operador}
                </span>
              </Tooltip>
              <span className="text-center"
                style={{
                  backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
                  color: anotation.corFonte ? anotation.corFonte : 'auto'
                }}
              >
                &nbsp;{formatDateTimeToRender(anotation?.dataAgendamento)}
              </span>
            </div>
            <p style={{
              backgroundColor: anotation.corFundo ? anotation.corFundo : 'auto',
              color: anotation.corFonte ? anotation.corFonte : 'auto'
            }}>
              &nbsp;{anotation?.ocorrencia}</p>
          </div>
        ))}
      </S.AnotationBody>
    </S.AnotationContainer>
  );
}

export default Anotations;
